export function truncate(str: string | undefined, maxlen: number): string {
  if (str) {
    return str.length > maxlen ? str.substring(0, maxlen) : str;
  } else {
    return '';
  }
}

export function overflow(str: string | undefined, len: number): string {
  if (str && len > 4) {
    return str.length > len ? str.substring(0, len - 3) + '...' : str;
  } else {
    return str ? str : '';
  }
}

export function isEmpty(str: string | undefined | null): boolean {
  if (!str) return true;
  if (str.trim() === '') return true;

  return false;
}

export function toBool(str: string | undefined): boolean {
  if (!str) {
    return false;
  }

  return str.toLowerCase() === 'true' ? true : false;
}

export const toNameInitial = (name: string): string => {
  let initials: string = '';
  if (name) {
    const nameParts = name.split(' ');
    nameParts.forEach((item: string) => {
      if (item.length > 0) {
        initials += item[0].toUpperCase();
      }
    });
  }

  return initials;
};

//lowercase letters and digits joined by single hyphens, accents dropped, at most maxLength characters: the API's
//StringExtensions.ToSlug, which makes a Skill key from a name
export function toSlug(value: string, maxLength: number = 64): string {
  const slug = value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return slug.length <= maxLength ? slug : slug.substring(0, maxLength).replace(/-+$/, '');
}

// A JSON text indented for display (tool-call arguments); a text that is not JSON, such as one cut at a length
// limit, is returned as it is
export function formatJsonText(text: string): string {
  try {
    return JSON.stringify(JSON.parse(text), null, 2);
  } catch {
    return text;
  }
}
